import React, { Component } from "react";
import { Helmet } from "react-helmet";
import ProductListing from "./common/product-listing";
import "../common/index.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addToWishlist } from '../../actions/wishlist';

import {
  getcollectionItems,
} from "../../actions/collection";
// import { addToCart, addToWishlist, addToCompare } from "../../actions";


class Collection extends Component {
  constructor() {
    super();
    this.state = {
      layoutColumns: 6,
      limit: 12,
      hasMoreItems: true,
    };
  }


  componentDidMount() {
    const {collection_id, connection_id} = this.props;
    this.props.getColletionItems({
      ...this.state,
      ...{ collection_id, connection_id},
    });
  }

  componentWillReceiveProps(nextProps) {
    const {connection_id} = this.props;
    if (nextProps.match.params.id !== this.props.match.params.id) {
        const collection_id  = nextProps.match.params.id ; 
        this.props.getColletionItems({
          ...this.state,
          ...{ collection_id,connection_id},
        });
    }
}

  fetchMoreItems = () => {
    if (this.state.limit >= this.props.count) {
      this.setState({ hasMoreItems: false });
      return;
    }
    // this.setState({page: this.state.page + 1})
    // const collection_id = process.env.REACT_APP_Collection_ID
    // const bar_code = ""
    // const category_id =  this.props.category_id
    // this.props.getMoreCollectionItems({...this.state,...{collection_id, bar_code, category_id}})
    setTimeout(() => {
      this.setState({
        limit: this.state.limit + 12,
      });
    }, 2000);
  };

  handleAddToWishlist = (lotCode) => {
    const {connection_id, consumer_mobile_no} = this.props
    const options = { connection_id, consumer_mobile_no, lot_code: lotCode }
    this.props.addToWishlist(options)
}

  render() {
    return (
      <div>
        {/*SEO Support*/}
        <Helmet>
        <title>{this.props.customer_name} | Collections </title>
          <meta name="description" content="" />
        </Helmet>
        {/*SEO Support End */}

        {/* <Breadcrumb title={'Collection'}/> */}

        <section className="section-b-space">
          <div className="collection-wrapper">
            <div className="container">
              <div className="row">
                {/* <div className="col-sm-3 collection-filter">
                  <StickyBox offsetTop={0} offsetBottom={20}>
                    <div>
                      <Filter {...this.props}/>
                    </div>
                  </StickyBox>
            
                </div> */}
                <div className="collection-content col">
                  <div className="page-main-content ">
                    <div className="">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="collection-product-wrapper">
                            {/*Products Listing Component*/}
                            <ProductListing
                              colSize={this.state.layoutColumns}
                              limit={this.state.limit}
                              hasMoreItems={this.state.hasMoreItems}
                              fetchMoreItems={this.fetchMoreItems}
                              addToWishlistClicked={this.handleAddToWishlist}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  // products: getVisibleproducts(state.data, state.filters),
  products: state.collection.products,
  count: state.collection.count,
  symbol: state.data.symbol,
  // categoryType: ownProps.match.params.type,
  collection_id: ownProps.match.params.id,
  loading: state.collection.loading,
  error: state.collection.error,
  connection_id: state.tenant.connection_id,
  customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
  consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // addToCart: addToCart,
      addToWishlist: addToWishlist,
      // addToCompare: addToCompare,
      getColletionItems: getcollectionItems
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Collection);
